import React, { Component } from "react";
import { Modal, Button, Form, Row, Col } from "react-bootstrap";
import DatePicker from "react-datepicker";
import { connect } from "react-redux";
import moment from "moment";
import { buildOptions } from "../utils";
import withFetchHook from "../withFetchHook";
import Creatable from "react-select/lib/Creatable";

class AbuseExperiencesFormModal extends Component {
  handleClose() {
    this.props.closeModal();
  }

  handleChange(name, value) {
    this.props.updateField(name, value);
  }

  updateResidentAbuseExperiences(abuseExperience) {
    const { organizationName, resident } = this.props;

    return this.props.fetch(`/organizations/${organizationName}/residents/${resident.id}.json`, {
      method: "PATCH",
      headers: {'Content-Type': 'application/json'},
      data: JSON.stringify({
        resident: {
          abuse_experiences_attributes: [abuseExperience]
        }
      })
    })
  }

  deleteAbuseExperience() {
    const { abuseExperience, deleteAbuseExperience, closeModal } = this.props;

    this.setState({ loading: true });

    this.updateResidentAbuseExperiences({
      id: abuseExperience.id,
      _destroy: true
    }).then(() => {
      this.setState({ loading: false });
      deleteAbuseExperience(abuseExperience);
      closeModal();
    });
  }

  saveAbuseExperience() {
    const { abuseExperience, updateAbuseExperiences, closeModal } = this.props;

    this.setState({ loading: true });

    this.updateResidentAbuseExperiences(abuseExperience).then((data) => {
      this.setState({ loading: false });
      updateAbuseExperiences(data.abuse_experiences);
      closeModal();
    });
  }

  render() {
    const { started_at, ended_at, notes, type_of_abuse } = this.props.abuseExperience;
    const typeOfAbuseOptions = buildOptions([
      "Domestic Violence", "Verbal Abuse", "Physical Abuse", "Sexual Abuse"
    ]);
    const typeOfAbuseValue = typeOfAbuseOptions.find((option) => option.value === type_of_abuse);
    return (
      <Modal show={this.props.show} onHide={this.handleClose.bind(this)}>
        <Modal.Header closeButton>
          <Modal.Title>Abuse History</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {this.props.hasEdit ? (
            <>
              <Form.Group controlId="abuseExperienceTypeOfAbuse">
                <Form.Label>Type of abuse</Form.Label>
                <Creatable
                  options={typeOfAbuseOptions}
                  value={typeOfAbuseValue}
                  onChange={(option) => {
                    this.handleChange('type_of_abuse', option.value)
                  }} />
              </Form.Group>
              <Row>
                <Col sm={6}>
                  <Form.Group controlId="abuseExperienceStartedAt">
                    <Form.Label>Started At</Form.Label>
                    <DatePicker
                      className="form-control"
                      selected={started_at ? moment(started_at) : null}
                      onChange={(date) => {
                        this.handleChange(
                          "started_at",
                          moment(date).format("YYYY-MM-DD")
                        )
                      }} />
                  </Form.Group>
                </Col>
                <Col sm={6}>
                  <Form.Group controlId="abuseExperienceEndedAt">
                    <Form.Label>Ended At</Form.Label>
                    <DatePicker
                      className="form-control"
                      selected={ended_at ? moment(ended_at) : null}
                      onChange={(date) => {
                        this.handleChange(
                          "ended_at",
                          moment(date).format("YYYY-MM-DD")
                        )
                      }} />
                  </Form.Group>
                </Col>
              </Row>
              <Form.Group controlId="abuseExperienceNotes">
                <Form.Label>Notes</Form.Label>
                <Form.Control
                  as="textarea"
                  value={notes}
                  onChange={(e) => {
                    this.handleChange("notes", e.target.value)
                  }} />
              </Form.Group>
            </>
          ) : (
            <>
              <Form.Group>
                <Form.Label>Type of abuse</Form.Label>
                <div className="form-control-plaintext">{type_of_abuse || 'N/A'}</div>
              </Form.Group>
              <Row>
                <Col sm={6}>
                  <Form.Group>
                    <Form.Label>Started At</Form.Label>
                    <div className="form-control-plaintext">{started_at ? moment(started_at).format('MM/DD/YYYY') : 'N/A'}</div>
                  </Form.Group>
                </Col>
                <Col sm={6}>
                  <Form.Group>
                    <Form.Label>Ended At</Form.Label>
                    <div className="form-control-plaintext">{ended_at ? moment(ended_at).format('MM/DD/YYYY') : 'N/A'}</div>
                  </Form.Group>
                </Col>
              </Row>
              <Form.Group>
                <Form.Label>Notes</Form.Label>
                <div className="form-control-plaintext">{notes || 'N/A'}</div>
              </Form.Group>
            </>
          )}
        </Modal.Body>
        <Modal.Footer>
          {
            this.props.action === "edit" && this.props.hasDelete &&
            <Button
              variant="outline-danger"
              onClick={() => this.deleteAbuseExperience()}>
              Delete
            </Button>
          }
          <Button
            variant="info"
            onClick={() => this.saveAbuseExperience()}>
            {this.props.action === "edit" ? "Update" : "Create"}
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    show: state.ui.abuseExperienceModal.show,
    abuseExperience: state.ui.abuseExperienceModal.abuseExperience,
    action: state.ui.abuseExperienceModal.action,
    organizationName: state.organization.name,
    resident: state.resident,
    hasDelete: state.current_user.permissions.includes('Delete'),
    hasEdit: state.current_user.permissions.includes('Edit')
  };
}

const mapDispatchToProps = (dispatch) => {
  return {
    closeModal: () => {
      dispatch({
        type: "CLOSE_RESOURCE_MODAL",
        payload: { resourceName: "abuseExperience" }
      });
    },
    updateField: (name, value) => {
      dispatch({
        type: "UPDATE_RESOURCE_FIELD",
        payload: { resourceName: "abuseExperience", name, value }
      });
    },
    updateAbuseExperiences: (abuseExperience) => {
      dispatch({
        type: "UPDATE_ABUSE_EXPERIENCE",
        payload: { abuseExperience }
      });
    },
    createAbuseExperience: (abuseExperience) => {
      dispatch({
        type: "CREATE_ABUSE_EXPERIENCE",
        payload: { abuseExperience }
      });
    },
    deleteAbuseExperience: (abuseExperience) => {
      dispatch({
        type: "DELETE_ABUSE_EXPERIENCE",
        payload: { abuseExperience }
      })
    }
  };
}

export default withFetchHook(connect(mapStateToProps, mapDispatchToProps)(AbuseExperiencesFormModal));
